module.exports = __webpack_public_path__ + "static/media/40-10.04a680ab.mp3";